import { AppLoader } from 'components/atoms';
import { StateInfoBase } from '../StateInfoBase/StateInfoBase';

export const LoadingDisplay = () => <StateInfoBase icon={<AppLoader size={112} />} />;
